import { Model, modelRegistry } from './Model';
import moment from 'moment-timezone';
import { HashGen } from '../utilities';
import { Store } from '../wrappers';
import { apiService, connectionService } from '../services';
export class Session extends Model {
    static entity = 'sessions';
    static primaryKey = 'hash';
    static syncable = true;
    /** As aria-api's Session::STALE_AFTER_HOURS: an open session older than this is a forgotten working day. */
    static STALE_AFTER_HOURS = 16;
    id = null;
    hash = '';
    clock_in = null;
    clock_out = null;
    user_id = null;
    ip_address = null;
    created_at = null;
    updated_at = null;
    static fields() {
        return {
            id: this.attr(null),
            hash: this.attr(HashGen.regular()),
            clock_in: this.attr(null),
            clock_out: this.attr(null),
            user_id: this.attr(null),
            ip_address: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    /**
     * Open and begun longer ago than STALE_AFTER_HOURS: a forgotten working day, not one in progress.
     */
    isStale() {
        return !this.clock_out && !!this.clock_in
            && moment().diff(moment.utc(this.clock_in), 'hours', true) > Session.STALE_AFTER_HOURS;
    }
    /**
     * Make a copy of the current session.
     */
    $duplicate() {
        return new Session(this.$toJson());
    }
    static async open(user) {
        const session = new Session({
            hash: HashGen.regular(),
            user_id: user.id,
            clock_in: moment().utc().format(Session.DATE_FORMAT)
        });
        return session.sync('create');
    }
    async close() {
        if (!this.hash)
            this.hash = HashGen.regular();
        this.clock_out = moment().utc().format(Session.DATE_FORMAT);
        return this.sync('update');
    }
    async sync(action) {
        const apiAction = action === 'delete' ? 'delete' : (!this.id ? 'post' : 'patch');
        const url = '/sessions' + (this.id ? `/${this.id}` : '');
        let record = this.$toJson();
        await this.markForSync(action);
        if (action === 'delete')
            this.$delete();
        else
            this.$save();
        if (!Store.get('isOnline')) {
            Session.syncTerminals({ items: [{ action: apiAction, record }] });
            return { success: true };
        }
        try {
            const response = await apiService[apiAction](url, record);
            if (response.data.record) {
                record = response.data.record;
                this.$fill(record);
                Session.insert({ data: [record] });
            }
            Session.syncTerminals({ items: [{ action: apiAction, record }] });
            await this.removeFromSync();
            return { success: true };
        }
        catch (error) {
            const isOnline = await connectionService.connectionCheckRetry(5000);
            return { success: isOnline };
        }
    }
}
export default Session;
modelRegistry.register('Session', Session);
//# sourceMappingURL=Session.js.map